<template>
    <div @click="selctCurSubGroup" class="prod_item">
        <div class="img_container">
            <img v-if="image != null && hasImage" :src="image" @error="()=> this.hasImage = false">
            <img v-else :src="noImageSrc">
        </div>
        <div class="name_container">
            <div class="container">
                <span class="name" v-text="name"></span>
            </div>
        </div>
    </div>
</template>

<script>

import Util from '@/assets/libs/util'

export default {
    name: 'SubGroupCard',
    props: [
        'name',
        'image',
        'subGroup',
        'subGroupIndex'
    ],
    data () {
        return {
            hasImage: true,
            noImageSrc: null,
            junk: require('../../static/icons/junk-icon.png')
        }
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
    },
    methods: {
        selctCurSubGroup: function () {
            let products = this.subGroup.products
            this.$emit('selectCurGroup', {products, subGroupIndex: this.subGroupIndex})
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>

    @import (reference) url("../assets/common.less");

    .prod_item {
        position: relative;
        background-color: @white;
        padding: 0;
        text-align: center;
        margin: 20px;
        box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
        border-radius: 5px;
        display: grid;
        grid-template-rows: 150px 160px;
        // height: 300px;
        .container{
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: calc(100% - 30px);
            padding: 0 15px;
        }
    }
    .img_container {
        img {
            object-fit: contain;
            width: 100%;
            max-height: 130px;
            height: auto;
            margin: auto;
            margin-top: 20px;
            display: block;
        }
    }
    .name_container {
        position: relative;
        .name {
            font-family: @default-font;
            font-size: 1.2rem;
            display: block;
            max-width: 100%;
            text-transform: uppercase;
            text-align: center;
            margin: auto;
            padding: 0;
        }
    }
    .price_container {
        position: relative;
        .from {
            text-transform: uppercase;
            font-size: 1rem;
            color: @primary-dark;
            padding-top: 15px;
        }
        .price {
            font-family: @default-font;
            font-size: 1.2rem;
            color: red;
            margin: 0;
        }
    }

    @media (max-width: 698px) { // Gertec SK210
        .prod_item {
            margin: 5px;
            grid-template-rows: 80px 70px;
        }
        .img_container {
            img {
                max-height: 70px;
                margin-top: 7px;
            }
        }
        .name_container {
            .name {
                font-size: 12px;
            }
        }
    }

    @media (min-width: 699px) and (max-width: 1025px) { //@tablet
        .prod_item {
            margin: 10px;
            grid-template-rows: 130px 120px;
            .container{
                width: calc(100% - 30px);
                padding: 0 15px;
            }
            &.slimMode {
                box-shadow: unset;
                grid-template-rows: 130px 120px;
            }
        }
        .img_container {
            img {
                max-height: 110px;
                margin-top: 10px;
            }
        }
        .name_container {
            .name {
                font-size: 1.2rem;
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/SubGroupCard.vue